<!--
 * @Author: Gaho
 * @Date: 2024-02-29 14:45:16
 * @LastEditors: Gaho
 * @LastEditTime: 2024-03-01 15:16:13
 * @Description: 
-->
<template>
    <GameSettingsButtonWrapper :tool-tip="$t('Rules')" :enable="modelValue" @click.self="onClick()">
        <QIcon @click.self="onClick()" name="help" />
    </GameSettingsButtonWrapper>
    <RuleDialog
        :data="data"
        :model-value="modelValue"
        @update:model-value="onModelValue"
    />
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import RuleDialog from './_components/ruleDialog.vue';

import { useI18n } from "vue-i18n";

export default defineComponent({
    name: 'ruleDialog',
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: 'corgiwild',
        },
    },
    components: {
        RuleDialog
    },
    emits: ['update:modelValue'],
    data(){
        return {
            data: [],
            $t: useI18n().t
        }
    },
    methods: {
        onModelValue(){
            this.$emit('update:modelValue', !this.modelValue);
        },
        onClick(){
            this.$emit('update:modelValue', !this.modelValue);
        }
    }
})
</script>
